import { merge } from 'rxjs'
import { scan, tap, catchError } from 'rxjs/operators'
import {
  distinctUntilChanged,
  shareLast,
  flog,
  stow,
} from '@zambezi/caballo-vivo'
import { fromJS } from 'immutable'
import {
  accessCancel$,
  accessesDisplay$,
  accessesForTppDisplay$,
  accessDetailsDisplay$,
} from './accesses'
import { checkForUserInteraction$ } from '@apiEnabler/ob-common/lib/intents'
import { authToken$ } from '@apiEnabler/ob-common/lib/url-params'
import {
  redirectIfUnauthenticated,
  logOut$,
} from '@apiEnabler/ob-common/lib/authorization'
import { simpleModal$ } from '@apiEnabler/api-enabler-common/lib/dialogs'
import { Brand } from '@apiEnabler/ob-common/lib/brand'
import { restore } from '@apiEnabler/ob-common/lib/errors'
import bootstrap$ from './bootstrap'
import location$ from './location'
import { isPayMeYouEnabled$ } from './paymeyou-config'
import { biometricsDisplay$ } from './biometrics'
import {
  payYouDisplay$,
  payMeDisplay$,
  payMeLinkHistory$,
  payYouLinkHistory$,
  payMeReusableLinkHistory$,
  linkCancel$,
} from './pay-me-you'
import { mortgagesDisplay$ } from './mortgages'
import { paymentsDisplay$, paymentDetailsDisplay$ } from './payments'
import { soPaymentsDisplay$, soPaymentDetailsDisplay$ } from './standing-orders'
import {
  fundsChecksDisplay$,
  fundsChecksForTppDisplay$,
  fundsCheckDetailsDisplay$,
  fundsCheckCancel$,
} from './funds-checks'
import {
  vrpDisplay$,
  vrpForTppDisplay$,
  vrpDetailsDisplay$,
  vrpCancel$,
} from './vrp'
import {
  sweepingDisplay$,
  sweepingForTppDisplay$,
  sweepingDetailsDisplay$,
  sweepingCancel$,
} from './sweeping'
import { failIfEbankingUnauthenticated } from './ebanking-backstop'
import { isStaffMember$, staffPortalSearchQuery$ } from './staff'
import expirationTimeRefreshPbb$ from './expiration-time-refresh-pbb'
import sessionExpiryAlertPbb$ from './session-expiry-alert-pbb'

export const reduceState = (state, changeFn) => changeFn(state)
const initialState = fromJS({ brand: new Brand() })

export const createStore$ = () =>
  merge(
    location$,
    biometricsDisplay$,
    payYouDisplay$,
    payMeDisplay$,
    payMeLinkHistory$,
    payYouLinkHistory$,
    payMeReusableLinkHistory$,
    linkCancel$,
    mortgagesDisplay$,
    paymentsDisplay$,
    paymentDetailsDisplay$,
    soPaymentsDisplay$,
    soPaymentDetailsDisplay$,
    fundsChecksDisplay$,
    fundsChecksForTppDisplay$,
    fundsCheckDetailsDisplay$,
    fundsCheckCancel$,
    accessesDisplay$,
    accessesForTppDisplay$,
    accessDetailsDisplay$,
    accessCancel$,
    vrpDisplay$,
    vrpForTppDisplay$,
    vrpDetailsDisplay$,
    vrpCancel$,
    sweepingDisplay$,
    sweepingForTppDisplay$,
    sweepingDetailsDisplay$,
    sweepingCancel$,
    bootstrap$,
    simpleModal$,
    expirationTimeRefreshPbb$,
    sessionExpiryAlertPbb$,
    logOut$,
    isPayMeYouEnabled$.pipe(stow('isPayMeYouEnabled')),
    isStaffMember$.pipe(stow('isStaffMember')),
    staffPortalSearchQuery$.pipe(stow('staffPortalSearchQuery')),
    authToken$.pipe(stow('authToken'))
  ).pipe(
    scan(reduceState, initialState),
    distinctUntilChanged,
    shareLast,
    tap(x => checkForUserInteraction$.next(x)),
    catchError(failIfEbankingUnauthenticated),
    catchError(redirectIfUnauthenticated),
    catchError(restore),
    flog('Store snapshot')
  )
const store$ = createStore$()
export default store$
